import { types } from "mobx-state-tree";
import { useEffect, useCallback } from "react";

const beforeUnload = (show: boolean) => {
  window.onbeforeunload = (event) => {
    if (show) {
      const e = event || window.event;
      e.preventDefault();
      if (e) e.returnValue = "";
      return "";
    }
  };
};

const leavePages = types
  .model("LeavePagesModel", {})
  .views((self) => ({
    get leavePagePrompt() {
      for (let page in self) {
        if (self[page]) return true;
      }
      return false;
    },
  }))
  .actions((self) => ({
    setPage(value: boolean, page: LeavePagesEnum) {
      self[page] = value;
    },
  }))
  .create();

export enum LeavePagesEnum {
  BatchVideoAnalysis,
  Upload,
  BatchHighlightDetection,
}

export const useLeavePagePrompt = () => {
  window.onload = () => beforeUnload(leavePages.leavePagePrompt);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => beforeUnload(leavePages.leavePagePrompt), [leavePages.leavePagePrompt]);

  return [
    useCallback((value: boolean, page: LeavePagesEnum) => leavePages.setPage(value, page), []),
  ];
};
